import { useCallback } from "react";
import { encodeEmail } from "utils/encode";
import useSession from "../hooks/useSession";

const useFetchWithAuth = () => {
  const session = useSession();
  const fetchWithAuth = useCallback(
    async (url, payload) => {
      if (session === "loading") {
        throw new Error("Session loading");
      }
      if (typeof session?.access_token !== "string") {
        await supabase.auth.signOut();
        navigate("/", { replace: true });
      }
      const appId = encodeEmail(session.user.email);
      if (!payload) {
        payload = {};
      }
      if (!payload.headers) {
        payload.headers = {};
      }
      console.log("Making request with at", session.access_token);
      payload.headers["Authorization"] = "Bearer " + session.access_token;
      payload.headers["ngrok-skip-browser-warning"] = "asdf";
      payload.headers["App-Id"] = appId;
      payload.headers["User-Email"] = session.user.email;

      return await fetch(url, payload);
    },
    [session]
  );

  return fetchWithAuth;
};

export default useFetchWithAuth;
